// MT — scripts propios de la tienda (vanilla JS, sin dependencias)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initVariantesProducto();
  initCantidadProducto();
  initFaq();
  initTilt();
  initParallax();
  initVideoFondo();
});

// Vídeo de fondo: bucle manual con un ligero desvanecido en el corte,
// para que la unión entre el último y el primer fotograma no se note a golpe.
function initVideoFondo() {
  var video = document.querySelector('[data-mt-video-fondo]');
  if (!video) return;
  if (mtReduceMotion) {
    video.pause();
    video.removeAttribute('autoplay');
    return;
  }
  var margenFinal = 0.5;
  var reiniciando = false;
  video.addEventListener('timeupdate', function () {
    if (!reiniciando && video.duration && video.duration - video.currentTime < margenFinal) {
      reiniciando = true;
      video.style.opacity = '0';
    }
  });
  // Solo saltamos el vídeo (currentTime = 0) cuando ya está totalmente
  // invisible (fin de la transición de opacidad), así el "salto" del
  // contenido nunca se ve — solo se percibe un respiro de luz.
  video.addEventListener('transitionend', function (e) {
    if (e.propertyName !== 'opacity' || video.style.opacity !== '0') return;
    video.currentTime = 0;
    video.play();
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        video.style.opacity = '1';
        reiniciando = false;
      });
    });
  });
}

var mtReduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Inclinación 3D suave siguiendo el cursor (tarjetas de foto)
function initTilt() {
  if (mtReduceMotion) return;
  var items = document.querySelectorAll('[data-mt-tilt]');
  if (!items.length) return;
  items.forEach(function (el) {
    el.addEventListener('mousemove', function (e) {
      var rect = el.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width - 0.5;
      var y = (e.clientY - rect.top) / rect.height - 0.5;
      el.style.transform = 'perspective(800px) rotateY(' + (x * 8) + 'deg) rotateX(' + (y * -8) + 'deg) translateY(-6px)';
    });
    el.addEventListener('mouseleave', function () {
      el.style.transform = '';
    });
  });
}

// Parallax suave en la foto del hero al hacer scroll (solo transform, sin bloquear el hilo principal)
function initParallax() {
  if (mtReduceMotion) return;
  var els = document.querySelectorAll('[data-mt-parallax] img');
  if (!els.length) return;
  var ticking = false;
  function actualizar() {
    els.forEach(function (img) {
      var rect = img.parentElement.parentElement.getBoundingClientRect();
      var progreso = (rect.top) / (window.innerHeight || 1);
      var desplazamiento = Math.max(-40, Math.min(40, progreso * 40));
      img.style.transform = 'translateY(' + desplazamiento + 'px)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(actualizar);
      ticking = true;
    }
  }, { passive: true });
  actualizar();
}

// Reveal al hacer scroll (IntersectionObserver compartido)
function initReveal() {
  var items = document.querySelectorAll('.mt-reveal');
  if (!items.length) return;
  if (!('IntersectionObserver' in window)) {
    items.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var delay = entry.target.getAttribute('data-mt-delay') || 0;
          setTimeout(function () {
            entry.target.classList.add('mt-visible');
          }, parseInt(delay, 10));
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  items.forEach(function (el) { observer.observe(el); });
}

// Galería de producto: click en miniatura cambia la imagen principal
function initGaleriaProducto() {
  var main = document.querySelector('[data-mt-galeria-principal]');
  if (!main) return;
  var thumbs = document.querySelectorAll('[data-mt-miniatura]');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var src = thumb.getAttribute('data-mt-full');
      var alt = thumb.getAttribute('data-mt-alt') || '';
      if (!src) return;
      main.src = src;
      main.alt = alt;
      thumbs.forEach(function (t) { t.classList.remove('mt-activa'); });
      thumb.classList.add('mt-activa');
    });
  });
}

// Selector de variantes: actualiza precio, id oculto y estado agotado
function initVariantesProducto() {
  var wrap = document.querySelector('[data-mt-producto-form]');
  if (!wrap) return;
  var dataEl = wrap.querySelector('[data-mt-variantes-json]');
  if (!dataEl) return;
  var variantes;
  try {
    variantes = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var idInput = wrap.querySelector('input[name="id"]');
  var precioActual = wrap.querySelector('[data-mt-precio-actual]');
  var precioAnterior = wrap.querySelector('[data-mt-precio-anterior]');
  var comprarBtn = wrap.querySelector('[data-mt-comprar]');
  var swatchGroups = wrap.querySelectorAll('[data-mt-opcion]');
  var galeriaPrincipal = document.querySelector('[data-mt-galeria-principal]');
  var miniaturas = document.querySelectorAll('[data-mt-miniatura]');

  function opcionesSeleccionadas() {
    var seleccion = [];
    swatchGroups.forEach(function (grupo) {
      var activo = grupo.querySelector('.mt-activo');
      seleccion.push(activo ? activo.getAttribute('data-mt-valor') : null);
    });
    return seleccion;
  }

  function formatearDinero(centavos) {
    return (centavos / 100).toLocaleString(document.documentElement.lang || 'es-ES', {
      style: 'currency',
      currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD',
    });
  }

  function actualizar() {
    var seleccion = opcionesSeleccionadas();
    var variante = variantes.find(function (v) {
      return v.options.every(function (op, i) { return op === seleccion[i]; });
    });
    if (!variante) return;
    idInput.value = variante.id;
    if (precioActual) precioActual.textContent = formatearDinero(variante.price);
    if (precioAnterior) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioAnterior.textContent = formatearDinero(variante.compare_at_price);
        precioAnterior.style.display = '';
      } else {
        precioAnterior.style.display = 'none';
      }
    }
    if (comprarBtn) {
      comprarBtn.disabled = !variante.available;
      comprarBtn.textContent = variante.available
        ? comprarBtn.getAttribute('data-mt-texto-disponible')
        : comprarBtn.getAttribute('data-mt-texto-agotado');
    }
    if (galeriaPrincipal && variante.imagen) {
      galeriaPrincipal.src = variante.imagen;
      galeriaPrincipal.alt = variante.imagen_alt;
      miniaturas.forEach(function (t) {
        var esLaMisma = t.getAttribute('data-mt-full') === variante.imagen;
        t.classList.toggle('mt-activa', esLaMisma);
      });
    }
  }

  swatchGroups.forEach(function (grupo) {
    grupo.querySelectorAll('[data-mt-valor]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        grupo.querySelectorAll('[data-mt-valor]').forEach(function (b) { b.classList.remove('mt-activo'); });
        btn.classList.add('mt-activo');
        actualizar();
      });
    });
  });
}

function initCantidadProducto() {
  var cont = document.querySelector('[data-mt-cantidad]');
  if (!cont) return;
  var input = cont.querySelector('input');
  cont.querySelectorAll('button').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var delta = parseInt(btn.getAttribute('data-mt-delta'), 10);
      var valor = Math.max(1, (parseInt(input.value, 10) || 1) + delta);
      input.value = valor;
    });
  });
}

// FAQ acordeón accesible
function initFaq() {
  var items = document.querySelectorAll('.mt-faq__item');
  if (!items.length) return;
  items.forEach(function (item) {
    var pregunta = item.querySelector('.mt-faq__pregunta');
    var respuesta = item.querySelector('.mt-faq__respuesta');
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-abierto');
      items.forEach(function (i) {
        i.classList.remove('mt-abierto');
        i.querySelector('.mt-faq__respuesta').style.maxHeight = null;
      });
      if (!abierto) {
        item.classList.add('mt-abierto');
        respuesta.style.maxHeight = respuesta.scrollHeight + 'px';
      }
    });
  });
}
